"use client";
import s from "./ArticleFeedback.module.scss";
import st from "@/components/pages/blog/ai-article/common.module.scss";
import cn from "classnames";

import { useEffect, useState } from "react";
import Image from "next/image";
import { Button } from "@/components/UI/Buttons/Button";

type ArticleFeedbackProps = {
  slug: string;
};

const LS_KEY = "blog_article_feedbacks";

enum DisplayStatuses {
  Unitialized = 1,
  VoteRequired,
  JustVoted,
  Done,
}

const ArticleFeedback = ({ slug }: ArticleFeedbackProps) => {
  const [status, setStatus] = useState<DisplayStatuses>(DisplayStatuses.Unitialized);
  const [feedbacksArr, setFeedbacksArr] = useState<string[]>([]);

  useEffect(() => {
    const storageData = localStorage.getItem(LS_KEY);

    if (!storageData) {
      setStatus(DisplayStatuses.VoteRequired);
      return;
    }

    try {
      const data = JSON.parse(String(storageData));

      if (!Array.isArray(data)) {
        setStatus(DisplayStatuses.VoteRequired);
        return;
      }

      setFeedbacksArr(data);
      setStatus(data.includes(slug) ? DisplayStatuses.Done : DisplayStatuses.VoteRequired);
    } catch (err) {
      setStatus(DisplayStatuses.VoteRequired);
    }
  }, [slug]);

  const handleVote = async (like: boolean) => {
    try {
      await fetch(`/api/rate-article?slug=${slug}&rate=${like}`);
    } catch (err) {}

    localStorage.setItem(LS_KEY, JSON.stringify([...feedbacksArr, slug]));
    setStatus(DisplayStatuses.JustVoted);
  };

  switch (status) {
    case DisplayStatuses.VoteRequired:
      return (
        <div className={s.wrapper}>
          <h3 className={cn(st.h4, s.title)}>Was this helpful?</h3>
          <div className={s.buttons}>
            <Button type="white" onClick={() => handleVote(true)} outline>
              Yes <Image src="/img/icons/shared/article/thumbs-up.png" alt="" width={24} height={24} />
            </Button>
            <Button type="white" onClick={() => handleVote(false)} outline>
              No <Image src="/img/icons/shared/article/thumbs-down.png" alt="" width={24} height={24} />
            </Button>
          </div>
        </div>
      );
    case DisplayStatuses.JustVoted:
    case DisplayStatuses.Done:
      return (
        <div className={s.wrapper}>
          <Image src="/img/icons/winking-face.png" alt="" width={48} height={48} quality={100} />
          <h3 className={st.h4}>Thank you for your feedback!</h3>
        </div>
      );
    default:
      return null;
  }
};

export default ArticleFeedback;
